export default __webpack_public_path__ + "static/galeria-hero-bg-5883a575b168c1a864899d88d547c668.png";